import React, { useState, useEffect } from "react";
import {DefaultButton, Dialog, DialogFooter, Dropdown, IDropdownStyles, PrimaryButton, TextField} from '@fluentui/react';
import { useSelector } from "react-redux";

const QuotaChange = ({defaultQuota, location, disabled, isreadonly, onUpdate}) => {

    const [possibilities, setPossibilities] = useState([])
    const [showApprovalDialog, setShowApprovalDialog] = useState(false)
    const [businessJustification, setBusinessJustification] = useState()
    const [quota, setQuota] = useState(defaultQuota)
    const [showBusinessJustificationError, setShowBusinessJustificationError] = useState(false)

    const allQuotas = useSelector(state => state.app.siteQuotas)

    useEffect(() => {
        let quotas = allQuotas
            .filter(x => x.locationId === location.id && x.quotaSize > quota)
            .map(x => x.quotaSize);
        
        quotas.unshift(quota);
        quotas.sort((a,b) => a - b);

        setPossibilities(
            quotas.map(x => ({
                key: x,
                text: `${x} GB`
            }))
        )
    }, [])

    const _onQuotaChange = (e, v) => {
        const selectedQuotaValue = v.key

        onUpdate('quotaValue', selectedQuotaValue, () => {
            if (selectedQuotaValue === defaultQuota) {
                onUpdate('quotaBusinessJustification', null)
            }
        })
        setQuota(selectedQuotaValue)

        if (selectedQuotaValue !== defaultQuota) {
            const selectedQuota = allQuotas.find(x => x.locationId === location.id && x.quotaSize === selectedQuotaValue)
            if (selectedQuota.approvalRequired) {
                setShowApprovalDialog(true)
            }
        }
    }

    const _onConfirmDialog = () => {
        if (!businessJustification) {
            setShowBusinessJustificationError(true)
            return
        }
        else {
            setShowBusinessJustificationError(false)
        }

        setShowApprovalDialog(false)
        onUpdate('quotaBusinessJustification', businessJustification)
    }

    const _onCancelDialog = () => {
        setQuota(defaultQuota)
        onUpdate('quotaValue', defaultQuota)

        setBusinessJustification()
        setShowBusinessJustificationError(false)
        setShowApprovalDialog(false)
    }

    const approvalDialog = 
        <Dialog 
            hidden={!showApprovalDialog}
            maxWidth={600}
            dialogContentProps={{
                title: 'Quota Change Approval Process'
            }}
            modalProps={{
                isBlocking: false
            }}
        >
            <div>
                <p>You are selecting quota that requires approval from your Line Manager and Service Owner.</p>
                <p>Before requesting higher quota you can consider performing cleanup activities on your site: removing old files, limiting versions in document library, deleting unused content etc. </p>
                <p>Please note that SharePoint and MS Teams are not archival storage applications and should not be used for such purpose. Official archiving tool in ABB is CASO: <a href="https://abb.service-now.com/_myservices?id=esc_sc_cat_item&table=sc_cat_item&sys_id=55e42656db26334098282e8405961979">Archive Request - CASO</a></p>
            </div>
            <TextField
                label="Business Justification"
                name="BusinessJustification"
                value={businessJustification}
                onChange={(e, v) => setBusinessJustification(v)}
                multiline
                rows={3}
                errorMessage={showBusinessJustificationError && !businessJustification ? "Business Justification required" : null}
            />
            <DialogFooter>
                <PrimaryButton onClick={_onConfirmDialog} text="Confirm" />
                <DefaultButton onClick={_onCancelDialog} text="Cancel" />
            </DialogFooter>
        </Dialog>

    return (
        <div style={containerStyles}>
            Request for quota change
            <Dropdown
                placeholder="Choose quota"
                onChange={_onQuotaChange}
                disabled={disabled || isreadonly}
                selectedKey={quota}
                options={possibilities}
                styles={dropdownStyles}
            />
            {approvalDialog}
        </div>
    )
}

const containerStyles = {
    marginTop: '14px',
    position: 'relative',
    width: '235px'
}

const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 200, marginTop:6 }
};
    
export default QuotaChange;





// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/QuotaChange.js